
import React from 'react'

import Paper from 'material-ui/Paper';

import { feedback as ROLES_CONFIG } from '../../../../config/roles';
import NewFeedbackTemplate from '../../../../components/feedback/NewFeedbackTemplate';

export default class FeedbackTemplatesCreate extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      role: this.props.authenticated ? this.props.authenticated.role : null
    }
  }

  render() {
    return (
      <div id="content">
        <div className="row">
          {
            ROLES_CONFIG.newFeedbackTemplate.indexOf(this.state.role) != -1 ?
              <Paper className="col-sm-11 ml-3-2vw h-100 mt-1vw p-0 customShadow" zDepth={3}>
                <NewFeedbackTemplate />
              </Paper> 
            : null
          }
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./routes/app/routes/feedback/FeedbackTemplatesCreate.js